export default __webpack_public_path__ + "static/media/ramen-busd.ae411d6c.svg";